export default (min, max, separator = '-') => {
  return [min, max].join(separator);
}
